export default __webpack_public_path__ + "static/media/pause-icon.74556b70.svg";